import React from 'react';
import SelectSingle from './SelectSingle';
import { AccountType } from '../../api';
import referencesService, { Account } from '../../services/references';
import useReferenceList from './useReferenceList';
import Progress from './Progress';
import { useSnackbar } from 'notistack';

export type { Account };

interface Props {
  types: Array<AccountType>;
  value: Pick<Account, 'id'> | undefined;
  onChange: (account: Account) => void;
}

const SelectSingleAccount: React.FunctionComponent<Props> = (props) => {
  const { data, error, loading } = useReferenceList('accounts', referencesService.getAccounts);
  const { enqueueSnackbar } = useSnackbar();

  if (error) {
    enqueueSnackbar('Failed to load accounts', { variant: 'error', autoHideDuration: 3000 });
  }

  if (loading) {
    return <Progress />;
  }

  const onChange = (value: Account | undefined) => {
    if (value) props.onChange(value);
  };

  const accounts = data || [];
  const selected = accounts.find((p) => p.id === (props.value && props.value.id));

  return (
    <SelectSingle<Account>
      selected={selected}
      onChange={onChange}
      data={accounts
        .filter((acc) => props.types.some((type) => type.toUpperCase() === acc.type))
        .sort((a, b) => (a.id > b.id ? 1 : a.id < b.id ? -1 : 0))}
      isClearable={false}
      label="Account"
      placeholder="Select account"
      optionValue={(option) => option.id}
      optionLabel={(option) => option.name}
    />
  );
};

export default SelectSingleAccount;
